import {scrollToWithDuration} from '../utils/scroll-to';

const initBarba = () => {
  window.barba.init({
    views: [{
      namespace: 'index',
      beforeLeave() {


      },
      beforeEnter(data) {

        if (data.current.namespace === 'lp') {
          const preloader = document.querySelector('.preloader');

          if (preloader) {
            preloader.classList.add('is-hide');
          }
        }

        window.dispatchEvent(new CustomEvent('reinit'));
      },
    },
    {
      namespace: 'lp',
      beforeEnter() {
        document.body.classList.remove('is-hide-lp');
        document.body.classList.add('is-show-lp');
        window.dispatchEvent(new CustomEvent('reinit'));
      },
      beforeLeave(data) {
        document.body.classList.remove('is-show-lp');
        document.body.classList.add('is-hide-lp');
      },
      afterEnter() {
        const id = window.location.hash;

        if (id) {
          setTimeout(() => {
            const target = document.querySelector(id);

            if (target) {
              const y = target.getBoundingClientRect().top + window.pageYOffset - Math.max(((window.innerHeight - target.offsetHeight) / 2), 120);
              scrollToWithDuration(y, 1000);
            }
          }, 1000);
        }
      }
    }],
    transitions: {
      leave: (data) => {
        const intro = data.current.container.querySelector('.intro');

        if (intro) {
          intro.classList.add('is-leave');
        }


        return new Promise(resolve => {
          setTimeout(() => {
            resolve();
          }, 550);
        });
      }
    }
  });
};

export {initBarba};
